var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C11.5523 0 12 0.447715 12 1V9H13V2C13 1.44772 13.4477 1 14 1H15C16.6568 1 17.9999 2.34325 18 4V8C17.5 8 17 8.5 17 9H18V9.99902C18 10.5513 17.5523 11 17 11H16.7305C16.3845 11.5973 15.7399 12 15 12C14.2601 12 13.6155 11.5973 13.2695 11H5.73047C5.38454 11.5973 4.73993 12 4 12C3.26007 12 2.61546 11.5973 2.26953 11H2C1.44772 11 1 10.5523 1 10V9H0V1C0 0.447715 0.447715 1.61064e-08 1 0H11ZM4 9C3.44772 9 3 9.44771 3 10C3 10.5523 3.44772 11 4 11C4.55228 11 5 10.5523 5 10C5 9.44771 4.55228 9 4 9ZM15 9C14.4477 9 14 9.44771 14 10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10C16 9.44771 15.5523 9 15 9ZM15 6H17V4C17 3.44772 16.5523 3 16 3H15V6Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truck-icon.d70fa497b830e250131b2f815ff97205.svg";
export { ForwardRef as ReactComponent };